import {
  CONSIGNMENT_RESULT_SET,
  CONSIGNMENT_RESULT_RESET
} from "../actionNames";

const initialState = {
  result: undefined
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CONSIGNMENT_RESULT_SET:
      return {
        ...state,
        result: action.result
      };

    case CONSIGNMENT_RESULT_RESET:
      return {
        ...state,
        result: undefined
      };

    default:
      return state;
  }
};
